<template>
    <div class="catalogue-form p-3">

        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-6">
                <div class="form-card rounded shadow-sm p-4">
                    <div class="mb-3">
                        <label for="label" class="form-label">Label *</label>
                        <input type="text" class="form-control" id="label" v-model="formData.label" required
                            placeholder="Ex: Printemps 2026" />
                    </div>

                    <!-- <div class="mb-3" v>
                            <label for="code" class="form-label">Code *</label>
                            <input type="text" class="form-control" id="code" v-model="formData.code" required
                                placeholder="Ex: CAT-001" />
                        </div> -->

                    <div class="mb-3">
                        <label for="description" class="form-label">Description</label>
                        <textarea class="form-control" id="description" v-model="formData.description" rows="3"
                            placeholder="Description du catalogue..."></textarea>
                    </div>

                    <div class="mb-4">
                        <label for="image" class="form-label">Image</label>
                        <input type="file" class="form-control" id="image" @change="takeFileInput($event, 'image')"
                            accept="image/*" />
                        <small class="text-muted">Formats acceptés: JPG, PNG, GIF. Taille max: 20MB</small>
                        <div v-if="currentImage" class="mt-2">
                            <img :src="currentImage" alt="Aperçu" class="img-fluid rounded"
                                style="max-height: 200px;" />
                        </div>
                    </div>

                    <div class="d-flex gap-2 justify-content-end">
                        <button type="button" class="btn btn-outline-secondary"
                            @click="$router.push({ name: 'catalogues.index' })">
                            Annuler
                        </button>
                        <button class="btn btn-purple" @click="save">
                            <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                            {{ isEdit ? 'Modifier' : 'Créer' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';

export default {
    name: 'CatalogueForm',
    mixins: [formMixin],
    data() {
        return {
            formData: {
                label: '',
                code: '',
                description: '',
                image: null
            },
            loading: false,
            isEditMode: false,
            maxImgSize: 20 * 1024 * 1024, // 20MB
            allowedImgTypes: ['image/jpeg', 'image/png', 'image/jpg'],
            url: '/catalogs'
        };
    },
    computed: {
        // url() {
        //     return '/catalogs';
        // },
        maxImgSizeMB() {
            return this.maxImgSize / (1024 * 1024);
        },
        currentImage() {
            return this.imageLink('image');
        }
    },
    methods: {
        // handleImageUpload(event) {
        //     const file = event.target.files[0];
        //     if (file) {
        //         // Validate file size (20MB max)
        //         if (file.size > this.maxImgSize) {
        //             this.$swal.fire(`La taille du fichier ne doit pas dépasser ${this.maxImgSizeMB}MB.`, '', 'error');
        //             return;
        //         }

        //         // Validate file type
        //         if (!this.allowedImgTypes.includes(file.type)) {
        //             this.$swal.fire('Format de fichier non supporté. Utilisez JPG, PNG.', '', 'error');
        //             return;
        //         }

        //         // this.formData.image = file;

        //         // Create preview
        //         // const reader = new FileReader();
        //         // reader.onload = (e) => {
        //         //     this.currentImage = e.target.result;
        //         // };
        //         // reader.readAsDataURL(file);

        //         this.takeFileInput(event, 'image');
        //     }
        // },
        // submitForm() {
        //     if (!this.formData.label.trim() || !this.formData.code.trim()) {
        //         this.$swal.fire('Erreur', 'Veuillez remplir tous les champs obligatoires.', 'error');
        //         return;
        //     }

        //     this.save();

        // },
        // loadCatalogue() {
        //     if (!this.isEdit) return;

        //     this.loading = true;
        //     this.$api.get(`${this.link}/${this.$route.params.id}`)
        //         .then(res => {
        //             const catalogue = res.data.data;
        //             this.formData.label = catalogue.label || '';
        //             this.formData.code = catalogue.code || '';
        //             this.formData.description = catalogue.description || '';
        //             this.currentImage = catalogue.image ? this.$api.defaults.assetsBaseURL + catalogue.image : null;
        //         })
        //         .catch(err => {
        //             console.error('Error loading catalogue:', err);
        //             this.$swal.fire('Erreur', 'Erreur lors du chargement du catalogue.', 'error');
        //             this.$router.push({ name: 'catalogues.index' });
        //         })
        //         .finally(() => {
        //             this.loading = false;
        //         });
        // }
    },

    // mounted() {
    //     this.isEditMode = this.$route.name === 'catalogues.edit';
    //     if (this.isEditMode) {
    //         this.loadCatalogue();
    //     }
    // }
};
</script>

<style scoped>
.catalogue-form {
    background: linear-gradient(130deg, #f8f2ff 0%, #fff 60%);
    min-height: 100vh;
}

.header-card {
    background-color: rgba(106, 74, 166, 0.12);
    border: 1px solid rgba(106, 74, 166, 0.3);
}

.form-card {
    border: 1px solid rgba(106, 74, 166, 0.18);
    background: #ffffff;
    box-shadow: 0 8px 24px rgba(106, 74, 166, 0.08);
}

.btn-purple {
    color: #fff;
    background-color: #6a4aa6;
    border-color: #6a4aa6;
}

.btn-purple:hover {
    color: #fff;
    background-color: #5a3a96;
    border-color: #5a3a96;
}

.btn-outline-secondary:hover {
    background-color: #6c757d;
    border-color: #6c757d;
}
</style>